module.exports = __webpack_public_path__ + "static/media/ic_chevron_left_24px.f074378d.svg";